module.exports = __webpack_public_path__ + "media/images/athletes/521-15ea67c017ce7c33af4b00c2ec90565d.png";